import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as Icon from '@material-ui/icons';
import { defaultStyles } from 'utils/Theme';
import { useHistory } from 'react-router-dom';
import {
    getAuthDropdownItems,
    getNotAuthDropdownItems,
} from './contants/accountDropdownItems';

const AccountDropdown = ({ isAuthenticated, logoutUserCallback }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const classes = defaultStyles();

    const authDropdownItems = isAuthenticated
        ? getAuthDropdownItems(history, logoutUserCallback)
        : getNotAuthDropdownItems(history);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                aria-controls="my-account"
                aria-haspopup="true"
            >
                <Tooltip title={'My Account'} arrow>
                    <Icon.AccountCircleOutlined
                        className={classes.colorPrimary}
                    />
                </Tooltip>
            </IconButton>

            <Menu
                id="my-account"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {authDropdownItems.map(({ title, action }, index) => (
                    <MenuItem key={`${index}_${title}`} onClick={action}>
                        {title}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

AccountDropdown.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    logoutUserCallback: PropTypes.func.isRequired,
};

export default AccountDropdown;
